import { getListCondition } from '@/api/common'

const state = {
  listCondition: [],
  breadList: []
}

const mutations = {
  SET_LIST_CONDITON (state, listCondition) {
    state.listCondition = listCondition
  },
  SET_BREAD_LIST(state, list) {
    state.breadList = list
  }
}

const actions = {
  async getListCondition({ state, commit }, params) {
    if (state.listCondition.length !== 0) { return false }
    const res = await getListCondition(params)
    let { code, data } = res.data
    if (code === 0) {
      commit('SET_LIST_CONDITON', data)
    }
    return res
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
